module.exports = __webpack_public_path__ + "static/Bootcamp-1-3b83efb784ebfa4a79cac7cdfecd191b.jpg";